module.exports = __webpack_public_path__ + "img/5.8ef764ec.png";